import { gql } from '@apollo/client';

export const hashCompletionsQuery = gql`
  query ($query: String!, $userOnly: Boolean!) {
    hashCompletions(query: $query, userOnly: $userOnly)
  }
`;

export const stripeKeysQuery = gql`
  query ($companyId: String) {
    stripeKeys(companyId: $companyId)
  }
`;

export const marketplaceShippingRatesQuery = gql`
  query {
    marketplaceShippingRates {
      country
      id
      amount
    }
  }
`;

export const marketplaceProductsQuery = gql`
  query ($product: String!) {
    marketplaceProducts(product: $product) {
      product
      label
      photo
      amount
      price
    }
  }
`;

export const marketplaceOrderQuery = gql`
  query ($id: String!) {
    marketplaceOrder(id: $id)
  }
`;

export const marketplaceOrdersQuery = gql`
  query ($filters: JSON, $after: String, $limit: Int) {
    marketplaceOrders(filters: $filters, after: $after, limit: $limit) {
      items {
        id
        title
        url
        status
        quantity
        createdAt
      }
      nextCursor
    }
  }
`;

export const companyShippingRatesQuery = gql`
  query ($id: String!) {
    companyShippingRates(id: $id)
  }
`;

export const documentQuery = gql`
  query ($id: String!) {
    document(id: $id) {
      _id
      createdAt
      data
      filename
      hash
      path
      appliedQRCodeData
      stored
      visibility
      transactions {
        transaction
        service
      }
      updatedAt
      uri
      userId
    }
  }
`;

export const getSharedDataQuery = gql`
  query {
    getSharedData
  }
`;

export const findLabelsByIdQuery = gql`
  query ($items: [String!]!) {
    findLabelsById(items: $items)
  }
`;

export const historyItemsQuery = gql`
  query HistoryItems($type: ItemType!, $page: Int!, $limit: Int!, $filters: [ItemsFilterInput!]!) {
    historyItems(type: $type, page: $page, limit: $limit, filters: $filters) {
      total
      items {
        id
        finalProduct
        label
        shared
        chain {
          id
          label
        }
        schema {
          id
          label
        }
        public
        qrCodeId
        uploadedAt
        createdAt
        users {
          id
          name
          vat
          image
          sharedAt
        }
      }
    }
  }
`;

export const verifyNotarizationQuery = gql`
  query ($hashes: [String!]!) {
    verifyNotarization(hashes: $hashes, services: [SEEDSBIT]) {
      _id
      filename
      hash
      stored
      uri
      transactions {
        service
        transaction
      }
    }
  }
`;

export const historyFiltersQuery = gql`
  query HistoryFilters {
    historyFilters {
      users {
        label
        value
        image
      }
      chains {
        label
        value
        items {
          process {
            label
            value
          }
          product {
            label
            value
          }
        }
      }
    }
  }
`;

export const itemWarningsQuery = gql`
  query ItemWarnings {
    itemsWarnings {
      id
      label
      type
    }
  }
`;

export const searchCompaniesQuery = gql`
  query ($q: String!, $items: [String!]!) {
    searchCompanies(q: $q, items: $items) {
      id
      name
      vat
    }
  }
`;

export const getNotificationsQuery = gql`
  query ($page: Int!, $limit: Int!, $after: String) {
    getNotifications(page: $page, limit: $limit, after: $after) {
      _id
      title
      type
      content
      read
      createdAt
      updatedAt
    }
  }
`;

export const companyPageQuery = gql`
  query ($id: String!, $lang: String) {
    companyPage(companyId: $id, lang: $lang) {
      mail
      website
      cover
      video
      logo
      gallery
      video
      isOwner
      languages
      body
      phone
      social
      shortDescription
      isOwner
      simplifiedSections
      defaultSimplifiedSections
      basicInfo {
        name
        category
        rea
        PEC
        ateco
        fiscalCode
        vatFiscalCode
        city
        country
        province
        region
        postalCode
        address
      }
    }
  }
`;

export const companyPageDefaultSimplifiedSectionsQuery = gql`
  query ($companyId: String!) {
    companyPage(companyId: $companyId) {
      defaultSimplifiedSections
      simplifiedSections
      basicInfo {
        category
      }
    }
  }
`;

export const certificationsQuery = gql`
  query Certifications($id: String, $lang: String) {
    certifications(id: $id, lang: $lang) {
      name
      document
      category
      languages
    }
  }
`;

export const companyInfoQuery = gql`
  query ($companyId: String!, $lang: String) {
    companyPage(companyId: $companyId, lang: $lang) {
      basicInfo {
        name
        category
      }
      logo
      cover
      shortDescription
      marketplaceEmail
      marketplaceEmail
    }
  }
`;

export const companyPagesQuery = gql`
  query ($limit: Int!, $page: Int!, $category: String, $all: Boolean) {
    companyPages(limit: $limit, page: $page, category: $category, all: $all) {
      total
      items {
        logo
        cover
        visible
        industryId
        name
        _id
        shortDescription
      }
    }
  }
`;

export const companyPageLogoQuery = gql`
  query ($companyId: String!) {
    companyPage(companyId: $companyId) {
      logo
    }
  }
`;

export const productsCompanyQuery = gql`
  query (
    $companyId: String
    $lang: String
    $category: String
    $hideIncluded: Boolean
    $ids: [String!]
  ) {
    productsCompany(
      companyId: $companyId
      lang: $lang
      category: $category
      hideIncluded: $hideIncluded
      ids: $ids
    ) {
      _id
      title
      category
      photo
      type
      published
      products
    }
  }
`;

export const productCompanyQuery = gql`
  query Product($productId: String!, $lang: String) {
    productCompany(productId: $productId, lang: $lang) {
      _id
      title
      description
      digitalLabel
      photo
      showTracking
      lotNumberSample
      video
      category
      productTrackingPage
      published
      lotPhoto
      gallery
      products
      simplifiedSections
      hasMarketplace
      type
      sections {
        id
        title
        content
        extra
        fields
      }
      lotPhotoDescription
      companyId
      companyName
      languages
      schemas
    }
  }
`;

export const profileQuery = gql`
  query Profile {
    profile {
      _id
      role
      firstName
      lastName
      services
      loggedAsAdmin
      photo
      company
      phone
      linkedIndustry
      email
      chains
      dockerPassword
      permissions
      excludedChains
    }
  }
`;

export const settingsQuery = gql`
  query Settings {
    settings {
      marketplaceNotificationMail
      canSupportLogin
      mainTour
    }
  }
`;

export const getItemSummaryQuery = gql`
  query GetItemSummary($source: String!, $lang: String!, $filters: [SummaryFilters!]!) {
    getItemSummary(source: $source, lang: $lang, filters: $filters)
  }
`;

export const subscriptionsSessionQuery = gql`
  query ($type: String!) {
    subscriptionsSession(type: $type)
  }
`;

export const itemExplorationQuery = gql`
  query ItemExploration(
    $id: String!
    $directions: [GraphDirection!]!
    $startDate: DateTime
    $endDate: DateTime
    $linkedEdges: Boolean
    $lang: String
  ) {
    itemExploration(
      source: $id
      directions: $directions
      startDate: $startDate
      endDate: $endDate
      linkedEdges: $linkedEdges
      graphLang: $lang
    )
  }
`;

export const itemQuery = gql`
  query ($id: String, $type: ItemFormatType!, $version: Int, $lang: String!) {
    item(id: $id, type: $type, version: $version, lang: $lang)
  }
`;

export const searchByLotQuery = gql`
  query ($lot: String!, $product: String!, $more: String, $lang: String!) {
    searchByLot(lot: $lot, product: $product, more: $more, lang: $lang) {
      label
      schema
      value
    }
  }
`;

export const itemStatsFilterIdsQuery = gql`
  query ($company: String) {
    itemStatsFilterIds(company: $company) {
      id
      label
    }
  }
`;

export const itemStatsQuery = gql`
  query ($page: Int!, $limit: Int, $filters: ItemStatsFiltersInput) {
    itemStats(page: $page, limit: $limit, filters: $filters) {
      items {
        label
        id
        date
        position {
          computed
          country
          region
          city
          province
        }
      }
      total
    }
  }
`;

export const searchQuery = gql`
  query ($query: String!, $types: [String!]!, $page: Int!, $limit: Int!, $lang: String) {
    search(query: $query, types: $types, page: $page, limit: $limit, lang: $lang) {
      items {
        id
        title
        type
        abstract
      }
      total
    }
  }
`;

export const ontologySchemasQuery = gql`
  query ($lang: String, $chain: String, $fromChainPlanner: Boolean) {
    ontologySchemas(lang: $lang, chain: $chain, fromChainPlanner: $fromChainPlanner)
  }
`;

export const ontologySchemaQuery = gql`
  query ($schema: String!, $splitIO: Boolean, $lang: String!) {
    ontologySchema(uri: $schema, splitIO: $splitIO, lang: $lang)
  }
`;

// Query Payments

export const getItemToUploadCountQuery = gql`
  query GetItemToUploadCount {
    getItemToUploadCount
  }
`;

export const getUsersVisibilityForChainQuery = gql`
  query ($id: String!) {
    getUsersVisibilityForChain(chainId: $id)
  }
`;

// Query Document

export const documentServicesQuery = gql`
  query {
    documentsServices
  }
`;

export const getDocumentPricesQuery = gql`
  query {
    getPrices
  }
`;

export const documentsQuery = gql`
  query ($limit: Int = 999, $page: Int = 0, $visibility: DocumentVisibility) {
    documents(limit: $limit, page: $page, visibility: $visibility) {
      items {
        _id
        filename
        uri
        certificationName
        certificationCategory
        transactions {
          service
          transaction
        }
        createdAt
      }
      total
    }
  }
`;

export const documentsAutocompleteQuery = gql`
  query Documents {
    documentsAutocomplete {
      label
      value
    }
  }
`;

export const chainsQuery = gql`
  query ($limit: Int = 999, $page: Int = 0, $purchasable: Boolean) {
    findAllChains(limit: $limit, page: $page, chainName: "", purchasable: $purchasable) {
      items {
        _id
        name
        createdAt
        userEmail
        userCanDelete
        disabledToAllUsers
        transaction
        containErrors
      }
      total
    }
  }
`;

export const getClientLimitQuery = gql`
  query {
    getClientsLimit
  }
`;

export const assignableUsersQuery = gql`
  query {
    assignableUsers {
      label
      value
    }
  }
`;

export const chainNameQuery = gql`
  query ($id: String!, $lang: String!) {
    chainName(id: $id, lang: $lang)
  }
`;

export const getGraphFromChainQuery = gql`
  query ($id: String!) {
    getGraphFromChain(id: $id)
  }
`;

export const getClientsQuery = gql`
  query ($page: Int!, $limit: Int!, $orderField: String, $directionField: String) {
    getClients(
      page: $page
      limit: $limit
      orderField: $orderField
      directionField: $directionField
    ) {
      total
      items {
        _id
        name
        isApp
        isCurrentClient
        createdAt
      }
    }
  }
`;

export const autocompleteQuery = gql`
  query ($schemas: [String!], $external: Boolean, $internal: Boolean, $sharer: String) {
    autocompleteItems(schema: $schemas, external: $external, internal: $internal, sharer: $sharer)
  }
`;

export const accountStatsQuery = gql`
  query AccountStats {
    accountStats
  }
`;

export const purchaseBlockchainCreditQuery = gql`
  query ($creditType: CreditType!) {
    purchaseBlockchainCredit(creditType: $creditType)
  }
`;

export const findAllQRCodeAssetsQuery = gql`
  query QrCodes($limit: Int!, $page: Int!, $assetQuery: String!) {
    findAllQRCodeAssets(
      page: $page
      limit: $limit
      assetQuery: $assetQuery
      orderField: "createdAt"
      directionField: "asc"
    ) {
      total
      assets {
        _id
        used
        name
      }
    }
  }
`;

export const availableBlockchainClientsQuery = gql`
  query {
    availableBlockchainClients
  }
`;

export const notificationsQuery = gql`
  query ($page: Int!, $limit: Int!, $after: String) {
    getNotifications(page: $page, limit: $limit, after: $after) {
      _id
      title
      type
      content
      read
      createdAt
      updatedAt
    }
  }
`;
